import { id } from "./id";
import { Status, status } from "./status";
import { Task, task } from "./task";
import { List, list } from "./list";
import { Identifiable } from "./identifiable";

type KanbanTask = Identifiable<Task> & { list: Identifiable<List> };

type Column = {
  status: Identifiable<Status>;
  tasks: KanbanTask[];
};

type Kanban = {
  columns: Column[];
};

const kanbanTask: KanbanTask = {
  ...task,
  uuid: id,
  list: { ...list, uuid: id },
};

const column: Column = {
  status: { ...status, uuid: id },
  tasks: [],
};

const kanban: Kanban = { columns: [] };

export type { Kanban, Column, KanbanTask };

export { kanbanTask, kanban, column };
